import React, { useState, FC, useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { TextField, Dialog, ApiException } from '@eta/components';
import {
    PrimaryButton,
    MessageBarType,
    MessageBar,
    Icon,
} from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { isNull } from 'util';
import { ReduxState } from '../../common/reducers';
import { otpVerifyUser, otpVerifyTaxpayer } from '../Redux/Actions';
import {
    LanguageTypes,
    ProfileType,
    ResendUserOTPRequest,
    ValidateTaxpayerOtpRequest,
    ValidationType,
} from '../../Services/ClientProxy/clientProxy';
import './Email.scss';
import { isEmptyText } from '../../helpers/utils';
import { validateContactDetails } from '../../ProviderManagement/Redux/Actions';
import { ContactTypes } from '../../ProviderManagement/Service/proxy';
import { ServiceCreator } from '../../Services/ClientProxy/ServiceFactory';
import { Defaults } from '../../common/config/constants';

const mapStateToProps = (state: ReduxState) => ({
    lastError: state.Verify.lastError
});

const mapDispatchToProps = {
    verify: otpVerifyUser,
    verifyTaxpayer: otpVerifyTaxpayer,
    verifyIntermediaryOTP: validateContactDetails
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export interface EmailDialogProps {
    NewEmail?: string;
    hidden: boolean;
    onClose: () => void;
    onSave: () => void;
    Type: string;
    verifyIntermediary?: boolean;
    taxpayerId?: number;
    preferredLanguage?: LanguageTypes | undefined;
}

const Email: FC<PropsFromRedux & EmailDialogProps> = (
    props: PropsFromRedux & EmailDialogProps
) => {
    const {
        NewEmail,
        hidden,
        onClose,
        verify,
        onSave,
        verifyTaxpayer,
        Type,
        lastError,
        verifyIntermediary,
        verifyIntermediaryOTP,
        taxpayerId,
        preferredLanguage
    } = props;
    const { t } = useTranslation(['resources']);
    const [verificationcode, setverificationcode] = useState<string>('');
    const [messageError, setmessageError] = useState<string>();
    const [seconds, setSeconds] = useState<number>(Defaults.ResendOTP);

    useEffect(() => {
        if (lastError) {
            setmessageError(lastError?.serviceError?.toString());
        }
    }, [lastError]);

    const handleVerifyClick = async () => {
        let response;
        if (verifyIntermediary) {
            response = await verifyIntermediaryOTP(taxpayerId || 0, verificationcode, ContactTypes.Email);
        } else {
            const body = new ValidateTaxpayerOtpRequest({
                validationType: ValidationType.Email,
            });
            if (Type === 'User') {
                response = await verify(body, verificationcode);
            } else {
                response = await verifyTaxpayer(body, verificationcode);
            }
        }
        if (isNull((await response.payload).lastError))
            onSave();
    };

    useEffect(() => {
        if (!hidden) {
            setverificationcode('');
            setmessageError('');
        }
    }, [hidden]);

    const renderTimer = (time: number) => {
        let second = (time % 60).toString();
        let minute = (Math.floor(time / 60)).toString();
        minute = minute.toString().length === 1 ? `0${minute}` : minute.toString();
        second = second.toString().length === 1 ? `0${second}` : second.toString();
        return `${minute}:${second}`;
    };

    useEffect(() => {
        if (seconds > 0) {
            setTimeout(() => setSeconds(seconds - 1), 1000);
        }
    });

    const resendOTP = async () => {
        try {
            const client = ServiceCreator.getTaxPayerProfileManagementClient(false);
            const response = await client.resendUserOtp(
                new ResendUserOTPRequest({
                    preferredLanguage: preferredLanguage ?? LanguageTypes.None,
                    profileType: (Type === 'User') ? ProfileType.TaxpayerRepresentative : ProfileType.TaxPayer,
                    validationType: ValidationType.Email,
                })
            );
            if (response) {
                // setCompleted(true);
                setSeconds(Defaults.ResendOTP);
            }
        } catch (ex) {
            const exception = ex as ApiException;
            setmessageError(exception.serviceError?.toString());
        }
    };

    return (
        <Dialog
            hidden={hidden}
            onDismiss={() => {
                onClose();
            }}
            maxWidth={450}
            title={(
                <>
                    <Icon iconName="MailCheck" /> {t('EmailVerification')}
                </>
            )}
        >
            <div className="contentEmail">
                {messageError && (
                    <div className="errorMessage">
                        <MessageBar
                            messageBarType={MessageBarType.error}
                            isMultiline={false}
                            onDismiss={() => setmessageError('')}

                        >
                            {messageError}
                        </MessageBar>
                    </div>
                )}

                <div className="messegeEmail bodyLine">
                    <div className="headerEmail">
                        <p>{t('form.verification.sentToMail')}</p>
                        <strong>{NewEmail}&nbsp;</strong>
                        {t('form.verification.sentToMail2')}
                    </div>
                    <br />
                </div>
                <div className="emailAlert bodyLine">
                    <p>{t('form.verification.emailAlert')}</p>
                    <p>{t('form.verification.emailAlert2')}</p>
                    <br />
                </div>
                <div className="emailCode bodyLine ClientDetails">
                    <TextField
                        value={verificationcode}
                        onChange={(_, v) => setverificationcode(v ?? '')}
                        maxLength={6}
                        autoFocus
                        placeholder={t('form.verification.verificationCode')}
                    />
                </div>
                <div>
                    <div className='resend'>
                        <span> {t('receive_SMS')} </span>
                        {seconds > 0 ? (
                            <div className='inline_Content'>
                                <span> {t('resend_code')} </span>
                                <span className='font_Timer'> {renderTimer(seconds)} </span>
                            </div>

                        ) : (
                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                <a href={undefined} className='Link_Button' onClick={() => resendOTP()}> {t('resend')} </a>
                            )}
                    </div>
                </div>
                <br />
                <div className="btnEmail bodyLine doneBtn">
                    <PrimaryButton
                        text={t('form-components.verify')}
                        onClick={() => handleVerifyClick()}
                        disabled={isEmptyText(verificationcode)}
                    />
                </div>
            </div>
        </Dialog>
    );
};
export default connector(Email);
